import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SiteExperienceConfiguration, SitePublicData } from '@luckycart/xpn-types';
import { GlobalExperienceState, Game } from '../common-types/GlobalExperienceState.type';

const initialState: GlobalExperienceState = {
  games: [],
  siteExperienceConfiguration: null,
  thumbnails: [],
  site: null,
};

export const globalExperienceSlice = createSlice({
  initialState,
  name: 'GlobalExperience',
  reducers: {
    setInitialExperienceData (
      state: GlobalExperienceState,
      { payload }: PayloadAction<{ siteConfiguration: SiteExperienceConfiguration, games: Game[], site: SitePublicData }>
    ): GlobalExperienceState {
      const thumbnails = payload.games
        .filter((game) => game.thumbnailUrl !== null)
        .map((game) => ({ campId: game.experience.operationId, url: game.thumbnailUrl as string }));
      return {
        ...state,
        games: payload.games,
        siteExperienceConfiguration: payload.siteConfiguration,
        thumbnails,
        site: payload.site,
      };
    },
  },
});

const { actions, reducer } = globalExperienceSlice;

export const { setInitialExperienceData } = actions;
export default reducer;
